import * as React from 'react';
import { DashboardLayout } from 'modules/App/components/Layout';
import logo from 'assets/icons/coming-soon.png';
import { useTranslation } from 'react-i18next';

/**
 * The shared "not built yet" page.
 *
 * `label` and `description` are both optional and both default to nothing
 * extra: three routes mount this component with no props at all
 * (`_routes.jsx` — /dashboard and the two supplier-invitation stubs), so the
 * bare render has to stay exactly what it was.
 *
 * @param {Object} props
 * @param {string} [props.label] Headline. Defaults to "Coming soon".
 * @param {string} [props.description] One line under the headline saying what
 *   is coming and why it isn't here yet. Omitted entirely when absent — an
 *   empty paragraph would still take the vertical space.
 */
export default function ComingSoonPage(props) {
  const { t } = useTranslation('common');
  return (
    <DashboardLayout>
      <p className="font-semibold text-xl mx-5 my-3">
        {props.label ?? t('comingSoon.title', 'Coming soon')}
      </p>
      {props.description ? (
        <p className="text-sm text-slate-500 mx-5 mb-3 max-w-2xl">{props.description}</p>
      ) : null}
      <img
        src={logo}
        alt={t('comingSoon.imageAlt', 'Coming soon')}
        className="ml-[30vw] mt-[25vh] h-[30vh]"
      />
    </DashboardLayout>
  );
}
